export default uiAttrDataTooltip = () ->
  scope: {
    uiAttrDataTooltip: '='
  }
  link: (s, el) ->
    s.$watch('uiAttrDataTooltip', (text) ->
      el.attr('data-tooltip', text)
    )